import React from 'react';
import { Col, Row } from 'reactstrap';

import PracticeExamHistory from '../../containers/DashboardContainers/practiceExamHistoryContainer';
import CircularLoading from '../Common/CircularLoading/CircularLoading';
import { Desktop, Mobile } from '../Common/const';
import PfeSktSwitch from '../Common/PfeSktSwitch/PfeSktSwitch';

class PracticeExamPageView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      fromPSView: !!window.localStorage.getItem('fromPSView'),
    };
  }

  componentDidMount() {
    // we already set it to a state variable so we remove this to avoid inconsistencies
    window.localStorage.removeItem('fromPSView');
  }

  getActiveTab = () => {
    const { pfeSktId, user } = this.props;
    if (
      !user?.rate?.isPfeOnly &&
      pfeSktId &&
      user?.rate?.id &&
      Number(pfeSktId) === Number(user.rate.id)
    ) {
      return 'SKT';
    }
    return 'PFE';
  };

  handleTabSwitch = (tab) => {
    const { user } = this.props;
    if (!user) return;
    if (tab === 'SKT') {
      this.props.setSwitchPfeSkt(user.rate.id);
    } else {
      this.props.setSwitchPfeSkt(user.pfeRate.id);
    }
  };

  render() {
    const activeTab = this.getActiveTab();
    const sktLocked =
      !this.props.userSubscription?.isOccupational ||
      this.props.user?.rate?.isPfeOnly;

    return (
      <div className="exams-container">
        {/* Desktop Layout */}
        <Desktop>
          <Row className="practice-exam-header-row m-0 row">
            <Col
              xs={12}
              className="d-flex justify-content-end align-items-center p-0"
            >
              <PfeSktSwitch
                activeTab={activeTab}
                onSwitch={this.handleTabSwitch}
                variant="toggle"
                size="md"
                sktLocked={sktLocked}
              />
            </Col>
          </Row>
        </Desktop>

        {/* Mobile Layout */}
        <Mobile>
          <div className="practice-exampage-mobile-section">
            <div className="d-flex justify-content-center mb-3">
              <PfeSktSwitch
                activeTab={activeTab}
                onSwitch={this.handleTabSwitch}
                variant="toggle"
                size="md"
                sktLocked={sktLocked}
              />
            </div>
          </div>
        </Mobile>
        {!this.props.pfeSktIdWaiting ? (
          <div className="practice-exam-history-section">
            <PracticeExamHistory
              batch={2}
              expirationWarningNextToAction
              fromPSView={this.state.fromPSView}
            />
          </div>
        ) : (
          <div className="text-center">
            <CircularLoading />
          </div>
        )}
      </div>
    );
  }
}

export default PracticeExamPageView;
